import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import type { DateFormat } from '../../../../common/model/index.tsx';
import type { ReleaseVersionValidationErrors, ReleasableVersion } from '../../../model/index.tsx';
import { releaseVersionUpdate } from '../../../state/actions.tsx';
import {
	getReleaseDate,
	getErrors,
	isSaving as isSavingSelector,
} from '../../../state/selectors.tsx';
import ReleaseDate from './view.tsx';

export type StateProps = {
	readonly isSaving: boolean;
	readonly releaseDate: DateFormat;
	readonly errors: ReleaseVersionValidationErrors;
};

export type OwnProps = {
	readonly intl: IntlShape;
};

export type DispatchProps = {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	readonly onInputChange: (arg1: Partial<ReleasableVersion>) => any;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapStateToProps = (state: any) => ({
	releaseDate: getReleaseDate(state),
	errors: getErrors(state),
	isSaving: isSavingSelector(state),
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const dispatcher = (dispatch: any) => ({
	// @ts-expect-error - TS7006 - Parameter 'version' implicitly has an 'any' type.
	onInputChange: (version) => dispatch(releaseVersionUpdate(version)),
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapDispatchToProps = (dispatch: any) => dispatcher(dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ReleaseDate);
